/**
 *
 * @example```js
 *   const queryObj = {
 *     "post_type": "post",
 *     "tax_query": {
 *       "taxonomy": "vertical",
 *       "field": "term_id",
 *       "terms": "4"
 *      }
 *    };
 *    const queryParam = encodeURIComponent(JSON.stringify(queryObj));
 *
 *    getQuery(
 *      queryParam,
 *      'aw-text',
 *      'wide',
 *      true,
 *      'index_item'
 *    ).then( res => res.json() ).then( res => console.log(res) );
 *
 * ```
 * @param query
 * @param imageSize
 * @param premiumMarkupType
 * @param getPostData
 * @param getMarkup
 * @return {Promise<any>}
 */
export async function getQuery( query, imageSize = '', premiumMarkupType = '', getPostData = true, getMarkup = '' ) {

    let url = `${window.location.origin}/wp-json/adw/v1/query/?query=${query}`;

    if ( imageSize ) {
        url += `&image_size=${imageSize}`;
    }

    if ( premiumMarkupType ) {
        url += `&premium_markup_type=${premiumMarkupType}`;
    }

    if ( getPostData ) {
        url += `&get_post_data=${getPostData}`;
    }

    if ( getMarkup ) {
        url += `&get_markup=${getMarkup}`;
    }

    try {

        const res = await fetch( url );

        return await res;

    } catch (e) {

        console.error('Developer message: Error in fetching query data: ' + e);

        throw e;

    }
}


/**
 *
 * @param query
 * @param getMarkup
 * @return {Promise<any>}
 */
export async function getQueryMarkup( query, getMarkup ) {

    const url = `${window.location.origin}/wp-json/adw/v1/query/?query=${query}&get_markup=${getMarkup}&get_post_data=false&taxonomy=${adw.posts.taxonomy}`;

    try {

        const res = await fetch( url );

        return await res;

    } catch (e) {

        console.error('Developer message: Error in fetching query markup data: ' + e);

        throw e;

    }
}

/**
 *
 * @param {string} query - encoded and stringified JSON object
 * @param {string} requestUri
 * @return {Promise<any>}
 */
export async function getQueryandPaginationMarkupForSearch(query, requestUri ) {

    const url = `${window.location.origin}/wp-json/adw/v1/query/?query=${query}&request_uri=${requestUri}&get_markup=index_item&get_post_data=false&pagination_markup=search_page_pagination`;

    try {

        const res = await fetch( url );

        return await res;

    } catch (e) {

        console.error('Developer message: Error in fetching query markup data: ' + e);

        throw e;

    }
}
